// @ts-nocheck

import { reduce } from 'lodash';

import { BasketModes, BasketStatuses, BasketItemStatuses, BetslipErrorCodes } from '../../../types/basket';

/**
 * Return the nextState corresponding to the
 * BASKET_SET_NOTIFICATION action
 *
 * @static
 * @param  {Object} state  The actual state
 * @param  {Object} action The action to reduce
 * @return {Object}        Return the new state.
 */
const basketSetNotification = (state, action) => {
  const { items, mode } = state;
  const { traderId, error: nextError, betslipId, additionalMessage } = action.payload;

  if (mode !== BasketModes.SIMPLE && traderId === state.traderId) {
    return {
      ...state,
      status: nextError.ecode === 0 ? BasketStatuses.VALIDATED : BasketStatuses.REJECTED,
      betslipId,
      additionalMessage: additionalMessage || undefined,
    };
  }

  const finalOddId = reduce(
    items,
    (found, item) => {
      if (found === false) {
        return item.traderId === traderId && item.oddId;
      }
      return found;
    },
    false,
  );

  if (items[finalOddId] !== undefined) {
    const item = items[finalOddId];
    const { status: itemStatus, error: itemError } = item;

    if (
      (nextError.ecode === BetslipErrorCodes.TRADER && itemStatus !== BasketItemStatuses.REJECTED) ||
      (nextError.ecode === 0 && itemStatus !== BasketItemStatuses.VALIDATED) ||
      itemError !== nextError
    ) {
      const nextItems = {
        ...items,
        [finalOddId]: {
          ...item,
          status: nextError.ecode === 0 ? BasketItemStatuses.VALIDATED : BasketItemStatuses.REJECTED,
          error: nextError,
          betslipId,
          additionalMessage: additionalMessage || undefined,
        },
      };

      return {
        ...state,
        items: nextItems,
      };
    }
  }
  return state;
};

export default basketSetNotification;
